export default "__VITE_ASSET__d894a075__"